(<template>
  <section v-if="badges.length"
           class="interpreter-badges__main-wrapper">
    <h2 v-if="!hideTitle"
        class="profile__section-title">
      <span>{{ $gettext("Approved interpreting skills") }}</span>
    </h2>
    <p class="interpreter-badges__one-area-subtitle">{{ subtitleText }}</p>
    <section v-if="showOnlyActive"
             class="interpreter-badges__wrapper">
      <article v-for="badge in activeBadges"
               :key="badge.type"
               :class="{active: badge.active}"
               class="interpreter-badges__one-area-cont">
        <figure :class="[badgeClass(badge)]"
                class="interpreter-badges__one-area"></figure>
        <p class="interpreter-badges__one-area-text">{{ badge.name }}</p>
      </article>
    </section>
    <section v-else
             class="interpreter-badges__wrapper">
      <article v-for="badge in interpreterOnlyBadges"
               :key="badge.type"
               :class="{active: badge.active}"
               class="interpreter-badges__one-area-cont">
        <figure :class="[badgeClass(badge)]"
                class="interpreter-badges__one-area"></figure>
        <p class="interpreter-badges__one-area-text">{{ badge.name }}</p>
      </article>
    </section>
  </section>
</template>)

<script>
  import {mapGetters} from 'vuex';

  export default {
    props: {
      params: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    computed: {
      ...mapGetters('UserInfoStore', [
        'userIsNotInterpreter'
      ]),
      paramsList() { return this.params || {}; },
      badges() { return this.params.badges || []; },
      activeBadges() { return this.interpreterOnlyBadges.filter((badge) => badge.active); },
      interpreterOnlyBadges() { return this.badges.filter((badge) => badge.context === 'interpreter'); },
      hideTitle() { return this.params.hideTitle; },
      subtitleText() {
        if (!this.showBadgesSection) return this.$gettext('The interpreter has not yet unlocked any skill badges.');
        return this.showOnlyActive ? this.$gettext('These digital fields show what kind of topics and assignment types the interpreter has experience with.') : '';
      },
      showOnlyActive() {
        if (this.userIsNotInterpreter || this.$route.name === 'ServerProfile') return true;
        return false;
      },
      showBadgesSection() {
        if (this.showOnlyActive) {
          if (this.activeBadges && this.activeBadges.length) return true;
          return false;
        } else if (this.badges.length) return true;
        return false;
      }
    },
    methods: {
      badgeClass(badge) {
        return badge.type ? badge.active ? `badge--${badge.type}_active` : `badge--${badge.type}` : '';
      }
    }
  };
</script>

<style scoped>
  .interpreter-badges__main-wrapper {
    display: block;
    width: 100%;
  }

  .interpreter-badges__wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0 -20px;
  }

  .interpreter-badges__one-area-subtitle {
    padding-bottom: 20px;
    color: rgba(0, 0, 0, 0.4);
  }

  .interpreter-badges__one-area-cont {
    position: relative;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    width: 100%;
    max-width: 290px;
    height: 60px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .interpreter-badges__one-area {
    display: block;
    flex: 1;
    width: 100%;
    height: 100%;
    margin: 0;
    margin-bottom: 5px;
    background-position: 50% 50%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .interpreter-badges__one-area-text {
    display: block;
    flex: 2;
    width: 100%;
    margin: 0;
    color: #000;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.3;
  }

  .active .interpreter-badges__one-area-text {
    color: #000;
  }
</style>

<style scoped src="@/assets/css/badges.css"></style>
